import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const FAQS = [
  { q: 'How does collection and delivery work?', a: "Book online and choose a collection day. Our team picks up from your doorstep, we clean everything with care, and we deliver it back to you — usually within about 48 hours. Collection and delivery are always free." },
  { q: 'Which areas do you cover?', a: 'We currently serve South West London, Central London, West London, Heathrow, Staines and Weybridge. Pop your postcode into the checker on our home page to make sure we cover you.' },
  { q: 'How long does it take?', a: 'Most orders are back with you within roughly 48 hours of collection. If you need something sooner, just get in touch and we’ll do our best.' },
  { q: 'How much does it cost?', a: 'Dry cleaning is charged per item, and laundry subscriptions start from £14.99. You can see everything on our pricing page.' },
  { q: 'How do I pay?', a: 'You can pay by card online, or by cash or bank transfer on collection — whatever’s easiest for you.' },
  { q: 'Can I change or cancel a subscription?', a: 'Absolutely. You can manage or cancel your subscription anytime from your dashboard — no long contracts, no fuss.' },
  { q: 'What if something is lost or damaged?', a: 'We treat every item with real care, but if anything ever goes wrong, contact us straight away and we’ll put it right.' },
  { q: 'Do you clean delicate or specialist items?', a: 'Yes — suits, dresses, coats, duvets and delicate knitwear are all in a day’s work. If you have something special, add a note to your order or get in touch first.' }
];

const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <div className="container" style={{ maxWidth: '760px' }}>
      <h1 className="section-title">Frequently asked questions</h1>
      <p className="section-sub">Everything you need to know. Still stuck? <Link to="/contact">Get in touch</Link>.</p>

      <div className="card">
        {FAQS.map((f, i) => (
          <div className="faq-item" key={i}>
            <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)} aria-expanded={open === i}>
              {f.q}
              <span style={{ color: 'var(--primary)', fontSize: '1.4rem' }}>{open === i ? '−' : '+'}</span>
            </button>
            {open === i && <div className="faq-a">{f.a}</div>}
          </div>
        ))}
      </div>

      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <Link to="/register" className="btn btn-accent btn-lg">Get started</Link>
      </div>
    </div>
  );
};

export default FAQ;
